// extracted by mini-css-extract-plugin
export default {"SkeletonItem":"SkeletonItem_SkeletonItem__AX1ah","skeleton":"SkeletonItem_skeleton__DpBR-"};